import { Redirect, Route, Switch } from "react-router-dom";
import { Flow } from "../../../../../shared/components/Flow";
import { StepAbout } from "./StepAbout";
import { StepHowItWorks } from "./StepHowItWorks";
import { StepCertify } from "./StepCertify";
import { StepPaymentMethod } from "./StepPaymentMethod";
import { useQueryPlanEnrollments } from "../../../../../query/benefits/useQueryPlanEnrollments";
import { WSQueries } from "../../../../../query/WSQuery";
import { PGLI_KEY, PLAN_DETAILS } from "../../../utils/constants";
import { selectorAvailablePlanEnrollments } from "../../../selectors/selectorAvailablePlanEnrollments";
import { useGetNow } from "../../../../../shared/hooks/useGetNow";
import { FlowStepStatus } from "../../../../../shared/components/FlowSwitch/types";

export const EnrollPGLI: React.FC<{
  basePath: string;
  goBack(): void;
}> = props => {
  const { basePath, goBack } = props;

  const now = useGetNow();

  // TODO(v3-blocker): plan enrollments have no implemented v3 home (see the read
  // hook), so this gate throws `NotMigrated` and the whole flow renders the
  // generic retry error instead of the enrollment steps.
  const qPlanEnrollments = useQueryPlanEnrollments({
    filter: {
      planType: "WingspanProfessionalLiabilityAndGeneralLiabilityInsurance"
    },
    sort: "createdAt"
  });

  return (
    <WSQueries queries={{ qPlanEnrollments }}>
      {({ qPlanEnrollmentsData }) => {
        const planEnrollment = selectorAvailablePlanEnrollments(
          qPlanEnrollmentsData,
          now
        ).find(Boolean);

        const isCompleted =
          planEnrollment?.status === "Active" ||
          planEnrollment?.status === "Terminated";
        const isPending = planEnrollment?.status === "Pending";

        const status: FlowStepStatus = isCompleted
          ? "Complete"
          : isPending
            ? "Pending"
            : "None";

        return (
          <Switch>
            <Route
              path={basePath}
              render={props => (
                <Flow
                  title="Insurance enrollment"
                  basePath={basePath}
                  hideNavigation={isCompleted || isPending}
                  steps={[
                    {
                      slug: "steps",
                      title: PLAN_DETAILS[PGLI_KEY].name,
                      steps: [
                        {
                          slug: "intro",
                          title: "Intro",
                          component: StepAbout
                        },
                        {
                          slug: "how-it-works",
                          title: "How it works",
                          component: StepHowItWorks
                        },
                        {
                          slug: "payment-settings",
                          title: "Payment settings",
                          component: StepPaymentMethod
                        },
                        {
                          slug: "certify",
                          title: "Certify & enroll",
                          component: StepCertify
                        }
                      ],
                      status,
                      result: {
                        Complete: {
                          description: (
                            <>
                              Congrats! You’re now covered under Wingspan Master
                              Professional & General Liability Insurance.
                            </>
                          ),
                          title: "Your enrollment was successful!"
                        },
                        Pending: {
                          description: (
                            <>
                              Your enrollment is pending. Please check back
                              later.
                            </>
                          ),
                          title: "Your enrollment is pending"
                        }
                      }
                    }
                  ]}
                  onBack={goBack}
                  onNext={goBack}
                />
              )}
            />

            <Redirect from="*" to={basePath} />
          </Switch>
        );
      }}
    </WSQueries>
  );
};
